import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AuthenticationFacade } from '../../state';

@Component({
    selector: 'cash-auth-callback',
    template: `<cash-loading></cash-loading>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuthCallbackComponent {
  constructor(private authenticationFacade: AuthenticationFacade) {
    this.authenticationFacade.tryLogin();
  }
}
